import { ModalService } from '@philips-internal/oswald-ui-components';
import { AuthenticationService, HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';

import { FoundationRoute } from '../constants';
import { Endpoint } from '../constants/endpoints';

export default function checkAssignTerms(): void {
  if (AuthenticationService.isAuthenticated()) {
    HttpService.get(Endpoint.CHECK_ASSIGN_TERMS).then((result) => {
      if (!result.body) {
        ModalService.openFullscreen({
          fragment: 'assign-terms',
          id: 'assign-terms',
        });
      } else {
        applicationContext.redirect(FoundationRoute.SPOTLIGHT as string);
      }
    }).catch((err) => {
      console.error('Error checking terms assignment:', err);
      ModalService.openFullscreen({
        fragment: 'assign-terms',
        id: 'assign-terms',
      });
    });
  }
}
